import { render, staticRenderFns } from "./email.vue?vue&type=template&id=8a713290"
import script from "./email.vue?vue&type=script&lang=ts"
export * from "./email.vue?vue&type=script&lang=ts"
import style0 from "./email.vue?vue&type=style&index=0&id=8a713290&prod&lang=scss"
import style1 from "./email.vue?vue&type=style&index=1&id=8a713290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports